import React from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import { getCurrentArticles } from "../../../actions/Users";
import { hostExists } from "../../../actions/Billings";
import Icon from "../../../components/Icon";
import Configuration, { translations } from "../../../config";
import { message } from "../../../actions";

const mapStateToProps = ( state ) =>
{
	return {
		articles: state.articles,
		fieldOptions: state.fieldOptions
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getCurrentArticles: () =>
		{
			dispatch( getCurrentArticles() );
		},
		hostExists: ( a_host ) =>
		{
			dispatch( hostExists( a_host ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class ScopeOfServicesFields extends React.Component
{
	constructor( props )
	{
		super( props );
		
		// Falls vorhanden, initial die Werte aus dem Local Storage befüllen
		this.state = this.props.fieldValues.article
			? this.props.fieldValues.article
			: {
				domains_count: null,
				users_count: null,
				contract_duration: null,
				price: null,
				summary_price: null,
				domains: [],
				current_domain_name: "",
				add_domain_action: false
			};
		
		this.domainInput = React.createRef();
		
		this.handleStep = this.handleStep.bind( this );
		this.handleEdit = this.handleEdit.bind( this );
		this.handleAddDomain = this.handleAddDomain.bind( this );
		this.handleRemoveDomain = this.handleRemoveDomain.bind( this );
	}
	
	componentDidMount()
	{
		// Hole buchbare Artikel
		this.props.articles.length === 0 && this.props.getCurrentArticles();
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
		const state = {};
		
		// Falls die Artikel geladen wurden, dann die Werte in den State befüllen
		if ( this.state.domains_count === null && Object.keys( this.props.articles ).length > 0 && Object.keys( this.props.fieldOptions ).length > 0 )
		{
			state["domains_count"] = parseInt( this.props.fieldOptions.domains_count );
			state["users_count"] = parseInt( this.props.fieldOptions.users_count );
			state["contract_duration"] = parseInt( this.props.fieldOptions.contract_duration );
			
			const articleId = `${this.props.fieldOptions.domains_count}-${this.props.fieldOptions.users_count}-${this.props.fieldOptions.contract_duration}`;
			const price = this.props.articles.hasOwnProperty( articleId )
				? this.props.articles[articleId]
				: null;
			
			if ( price > 0 )
			{
				state["price"] = price;
			}
		}
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
		
	} // function componentDidMount()
	
	componentDidUpdate( prevProps, prevState )
	{
		// Den Fokus nach jeder Aktion auf das Domaineingabefeld setzen
		this.domainInput.current.focus();
		
		const state = {};
		
		// Summe neu Berechnen falls die Anzahl der Domains sich ändert
		if ( JSON.stringify( prevState.domains ) !== JSON.stringify( this.state.domains ) )
		{
			state["summary_price"] = parseFloat( this.state.price ) * this.state.domains.length;
		}
		
		// Falls die Artikel geladen wurden, dann die Werte in den State befüllen
		if ( this.state.domains_count === null && Object.keys( this.props.articles ).length > 0 && Object.keys( this.props.fieldOptions ).length > 0 )
		{
			state["domains_count"] = parseInt( this.props.fieldOptions.domains_count );
			state["users_count"] = parseInt( this.props.fieldOptions.users_count );
			state["contract_duration"] = parseInt( this.props.fieldOptions.contract_duration );
			
			const articleId = `${this.props.fieldOptions.domains_count}-${this.props.fieldOptions.users_count}-${this.props.fieldOptions.contract_duration}`;
			const price = this.props.articles.hasOwnProperty( articleId )
				? this.props.articles[articleId]
				: null;
			
			if ( price > 0 )
			{
				state["price"] = price;
			}
		}
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
	} // function componentDidUpdate()
	
	/**
	 * Zwischen den Schritten wechseln und die Eingaben merken
	 *
	 * @param {Object} a_event Handler
	 * @param {boolean} a_next Nächster|Vorheriger Schritt
	 */
	handleStep( a_event, a_next = true )
	{
		// Wenn keine Domain angegeben wurde
		if ( a_next && this.state.current_domain_name.length === 0 && this.state.domains.length === 0 )
		{
			return this.props.message( "Bitte fügen sie mindestens eine Domain hinzu.", "warning" );
		}
		
		// Wenn die Domain nicht mit dem Plus hinzugefügt wurde,
		// und nicht bereits im Warenkorb vorhanden ist, dann diese dennoch übernehmen
		if ( this.state.current_domain_name.length > 0 && this.state.domains.indexOf( this.state.current_domain_name ) === -1 )
		{
			const state = { ...this.state };
			
			if ( this.state.domains.length > 0 )
			{
				state["domains"].unshift( this.state.current_domain_name );
				state["summary_price"] = parseFloat( state.price ) * this.state.domains.length;
			}
			else
			{
				state["domains"] = [ this.state.current_domain_name ];
				state["summary_price"] = parseFloat( state.price );
			}
			
			state["add_domain_action"] = false;
			state["current_domain_name"] = "";
			
			this.setState( state );
			this.props.saveValues( state, "article" );
		}
		else
		{
			this.props.saveValues( this.state, "article" );
		}
		
		if ( a_next )
		{
			this.props.nextStep();
		}
		else
		{
			this.props.previousStep();
		}
		
	} // function handleStep(...)
	
	/**
	 * Die Eingabe der Domain merken
	 *
	 * @param {Object} a_event Handler
	 */
	handleWrite( a_event )
	{
		const state = {};
		state["current_domain_name"] = a_event.target.value.toLowerCase();
		state["add_domain_action"] = a_event.target.value.length > 0;
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
		
	} // function handleWrite(...)
	
	/**
	 * Ändert eine eingegebene Domain
	 *
	 * @param {Object} a_event Handler
	 * @param {number} a_id Datensatz Id
	 */
	handleEdit( a_event, a_id )
	{
		const domains = [ ...this.state.domains ];
		domains[a_id] = a_event.target.value;
		this.setState( { domains: domains } );
		
	} // function handleEdit(...)
	
	/**
	 * Fügt eine neue Domain hinzu
	 *
	 * @param {Object} a_event Handler
	 */
	handleAddDomain( a_event )
	{
		a_event.preventDefault();
		
		const state = {};
		state["domains"] = [ ...this.state.domains ];
		
		if ( state["domains"].indexOf( this.state.current_domain_name ) !== -1 )
		{
			return this.props.message( "Die Domain wurde bereits hinzugefügt", "warning", 5000 );
		}
		
		if ( !this.state.current_domain_name.match( Configuration.domainRegex ) )
		{
			return this.props.message( "Die Domain ist ungültig und kann nicht verwendet werden.", "error" );
		}
		
		this.props.hostExists( this.state.current_domain_name );
		
		state["domains"].unshift( this.state.current_domain_name );
		state["current_domain_name"] = "";
		state["add_domain_action"] = false;
		state["summary_price"] = parseFloat( this.state.price ) * state["domains"].length;
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
		
	} // function handleAddDomain(...)
	
	/**
	 * Löscht eine Domain aus der Liste
	 *
	 * @param a_event
	 * @param a_host
	 */
	handleRemoveDomain( a_event, a_host )
	{
		a_event.preventDefault();
		
		let domains = [ ...this.state.domains ];
		domains = domains.filter( host => a_host !== host );
		this.setState( {
			domains: domains,
			summary_price: domains.length > 0
				? parseFloat( this.state.price ) * domains.length
				: parseFloat( this.state.price )
		} );
		
	} // function handleRemoveDomain(...)
	
	render()
	{
		return <div className={"col s12 unset-padding relative"}>
			<div className={"col s12 l7 xl8 unset-padding shoppingCart"}>
				<div className={"col s12 m7 xl8 relative"}>
					<div className={"cleared"}/>
					<h5>Domain hinzufügen</h5>
					<p>Bitte fügen sie mindestens eine Domain hinzu</p>
					<div className={"col s10 m5 l6 xl7 unset-padding domainField"}>
						<label>
							<div className="form-element-name tRight">Pflichtfeld <span className="form-element-required">*</span></div>
						</label>
						<input autoFocus
						       ref={this.domainInput}
						       className={"autoFocus"}
						       type={"text"}
						       name={"addDomain"}
						       value={this.state.current_domain_name}
						       onChange={( event ) => this.handleWrite( event )}/>
						{
							this.state.add_domain_action && <div className={"absolute inputButtons"}>
								<button key={"add_domain"}
								        onClick={( event ) => this.handleAddDomain( event )}
								        className={"btn btn-small btn-flat primary-color white-text hover-white hover-primary-color-text"}
								        title={"Domain hinzufügen."}>
									<Icon iconName={"add"}/>
								</button>
							</div>
						}
					</div>
					<div className={"cleared"}/>
					<h6 className={"underline"}>Vertragsbedingungen</h6>
					<p>Die gebuchte Domain kann zum Monatsende gekündigt werden.</p>
					<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
						At vero eos et accusam et justo duo dolores et ea rebum. </p>
					<p>Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
						dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos
						et accusam et justo duo dolores et ea rebum.</p>
				</div>
				<div className={"col s10 m5 xl4 domainTable"}>
					<h3>Warenkorb</h3>
					{
						this.state.domains && Object.keys( this.state.domains ).map(
							a_key =>
							{
								if ( this.state.domains.hasOwnProperty( a_key ) )
								{
									const domain = this.state.domains[a_key];
									
									return <div className={"col s12 unset-padding-left relative"} key={`domain_${a_key}`}>
										<p className={"col s10 unset-margin unset-padding-right"} key={`domain_name_${a_key}`}>{domain}</p>
										{
											<p className={"col s2 unset-margin unset-padding-right"}>
												<button key={`remove_domain_${a_key}`}
												        className={"btn btn-small btn-flat hover-red red-text hover-white-text right unset-margin"}
												        onClick={( event ) => this.handleRemoveDomain( event, domain )}
												        title={"Domain entfernen."}>
													<Icon iconName={"delete"}/>
												</button>
											</p>
										}
									</div>;
								}
								
								return null;
							}
						)
					}
				</div>
				<div className={"cleared spacer"}/>
			</div>
			
			<div className={"col s12 l5 xl4 light-grey right-block unset-radius dashed-block-outer"}>
				<div className={"relative"}>
					<div className={"col s12 dashed-block padding-top"}>
						<div className={"col s6 price"}>
							<div className={"padding-top"}>
								<label className={"primary-color-text"}>Anzahl Domains</label>
							</div>
							<span className={"value sub"}>{this.state.domains.length}</span>
							<span className={"additional"}>X</span>
						</div>
						<div className={"col s6 price tRight"}>
							<div className={"padding-top"}>
								<label className={"primary-color-text"}>Preis pro Domain</label>
							</div>
							<span className={"value sub"}>
							 {this.state.price > 0
								 ? ( parseFloat( this.state.price ) ).toLocaleString( Configuration.location, Configuration.priceString )
								 : "-,--"}
							 </span>
							<span className={"additional"}>Euro</span>
						</div>
						<div className={"col s12 summaryFields"}>
							<div className={"primary-color-text unset-padding oneLine margin-bottom"}/>
							<div className={"cleared"}/>
							<div className={"netField price"}>
								<label className={"col s4 unset-padding primary-color-text margin-top"}>Netto</label>
								<div className={"col s8 unset-padding tRight"}>
									<span className={"value"}>
									 {this.state.summary_price > 0
										 ? ( parseFloat( this.state.summary_price ) ).toLocaleString( Configuration.location, Configuration.priceString )
										 : "-,--"}
									 </span>
									<span className={"additional"}>Euro</span>
								</div>
							</div>
							<div className={"taxField price"}>
								<label className={"col s4 unset-padding primary-color-text margin-top"}>zzgl. 19% USt.</label>
								<div className={"col s8 unset-padding  tRight"}>
									<span className={"value"}>
									 {this.state.summary_price > 0
										 ? ( parseFloat( this.state.summary_price ) * 0.19 ).toLocaleString( Configuration.location, Configuration.priceString )
										 : "-,--"}
									 </span>
									<span className={"additional"}>Euro</span>
								</div>
							</div>
							<div className={"cleared"}/>
							<div className={"primary-color-text unset-padding summaryLine margin-top"}/>
							<div className={"grossField price"}>
								<label className={"col s4 unset-padding primary-color-text margin-top"}>Brutto</label>
								<div className={"col s8 unset-padding tRight"}>
									<span className={"value"}>
									 {this.state.summary_price > 0
										 ? ( parseFloat( this.state.summary_price ) * 1.19 ).toLocaleString( Configuration.location, Configuration.priceString )
										 : "-,--"}
									 </span>
									<span className={"additional"}>Euro</span>
								</div>
							</div>
							<div className={"price tRight"}>
								<span className={"additional"}>pro Monat</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={"cleared spacer"}/>
			<div className={"col s12 unset-padding relative"}>
				<button className={"secondary-color"} type={"button"} onClick={a_event => this.handleStep( a_event, false )}>
					<Icon key={`form-new-user-cancel-icon`} iconName={"leave"}/>
					<span key={`form-new-user-cancel-text`}>Zurück zu persönlichen Daten</span>
				</button>
				<button type={"button"} onClick={a_event => this.handleStep( a_event )}>
					<Icon key={`form-new-user-icon`} iconName={"next"}/>
					<span key={`form-new-user-text`}>nächster Schritt</span>
				</button>
			</div>
		</div>;
		
	} // function render()
	
} // class

ScopeOfServicesFields = connect(
	mapStateToProps,
	mapDispatchToProps
)( ScopeOfServicesFields );

export default ScopeOfServicesFields;
